<template>


  <div class="container mt-5">
    <div class="row">
      <div class="col">

        <!--         INICIO BOTON NOTICIA -->

        <div class="boton-agregar">
          <button data-text="Awesome" class="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
            <span class="actual-text">&nbsp;+noticia&nbsp;</span>
            <span class="hover-text" aria-hidden="true">&nbsp;+noticia&nbsp;</span>
          </button>
        </div>
        <!--         FIN BOTON NOTICIA -->

        <!--         INICIO TABLA-->

        <table class="table table-dark table-striped">
          <thead>
          <tr>
            <th scope="col">Id</th>
            <th scope="col">Url</th>
            <th scope="col">Texto</th>
            <th scope="col">Editar</th>
            <th scope="col">Eliminar</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="noticia in noticias">
            <th scope="row">{{noticia.id}}</th>
            <td>{{noticia.urlImg.substring(8, 20)}}</td>
            <td>{{noticia.texto}}</td>
            <td>
              <button @click="obtenerId(noticia.id)" type="button" class="btn btn-outline-warning" data-bs-toggle="modal" data-bs-target="#updateModal">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"></path>
                  <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"></path>
                </svg>
              </button>
            </td>
            <td>
              <button @click="eliminarNoticia(noticia.id)" type="button" class="btn btn-outline-danger">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"></path>
                  <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"></path>
                </svg>
              </button>
            </td>
          </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>


  <!--  INICIO MODAL GUARDAR-->

  <!-- Modal -->
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Agregar Noticia</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <div class="input-group">
            <input v-model="noticiaDto.urlImg" required="" type="text" name="text" autocomplete="off" class="input">
            <label class="user-label">Url</label>
          </div>

          <div class="input-group mt-5">
            <input v-model="noticiaDto.texto" required="" type="text" name="text" autocomplete="off" class="input">
            <label class="user-label">Texto</label>
          </div>


        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
          <button @click="guardarNoticia" type="button" class="btn btn-primary">Guardar</button>
        </div>
      </div>
    </div>
  </div>
  <!--  FIN MODAL GUARDAR-->


  <!--  INICIO MODAL ACTUALIZAR-->

  <!-- Modal -->
  <div class="modal fade" id="updateModal" tabindex="-1" aria-labelledby="updateModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Actualizar Noticia</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <div class="input-group">
            <input v-model="nombreNoticia.urlImg" required="" type="text" name="text" autocomplete="off" class="input">
            <label class="user-label">Url</label>
          </div>

          <div class="input-group mt-5">
            <input v-model="nombreNoticia.texto" required="" type="text" name="text" autocomplete="off" class="input">
            <label class="user-label">Texto</label>
          </div>


        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
          <button @click="editarNoticia" type="button" class="btn btn-primary">Guardar</button>
        </div>
      </div>
    </div>
  </div>
  <!--  FIN MODAL ACTUALIZAR-->

</template>

<script>
import {useStore} from "vuex";
import {computed, onBeforeMount, ref} from "vue";

export default {
  name: "Noticia",
  setup(){

    const store = useStore();
    const url = computed(() => store.state.userStore.url);
    const token = computed(() => store.state.userStore.token);
    let noticiaDto = ref({});
    let nombreNoticia = ref({});
    let noticias = ref([]);

    onBeforeMount(() => {
      cargarNoticias()
    });

    const cargarNoticias = async () => {
      const res = await fetch(`${url.value}/api/noticia`);
      noticias.value = await res.json();

    }

    const guardarNoticia = async () => {
      const res = await fetch(`${url.value}/api/noticia`, {
        method:'POST',
        mode:'cors',
        headers:{
          'token':token.value,
          'Content-Type': 'application/json'
        },
        body:JSON.stringify(noticiaDto.value)
      });
      const datos = await res.json();
      if(res.status == 201){
        noticiaDto.value.nombre = "";
        swal("Excelente!", "Contacto guardada con exito!", "success");
        noticias.value.push(datos);
      }
      if (res.status == 400){
        swal("Error!", `${datos.mensaje}`, "error");
      }

    }

    const obtenerId = async (id) => {

      const noticia = noticias.value.find(cat => cat.id == id);
      nombreNoticia.value.urlImg = noticia.urlImg;
      nombreNoticia.value.texto = noticia.texto;
      nombreNoticia.value.id = id;

    }

    const editarNoticia = async () => {

      const res = await fetch(`${url.value}/api/noticia/${nombreNoticia.value.id}`,{
        method:'PUT',
        mode:'cors',
        headers:{
          'token':token.value,
          'Content-Type': 'application/json'
        },
        body:JSON.stringify(nombreNoticia.value)
      });
      if (res.status == 201){
        noticias.value.forEach(cat => {
          if(cat.id == nombreNoticia.value.id){
            cat.urlImg = nombreNoticia.value.urlImg;
            cat.texto = nombreNoticia.value.texto;
          }
        })
        swal("Excelente!", "Noticia Actualizada con exito!", "success");
      }
      const datos = await res.json();

    }


    const eliminarNoticia = async (id) => {

      swal({
        title: "Estas seguro?",
        text: "una vez borrado, no se pordra recuperar",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
          .then(async (willDelete) => {
            if (willDelete) {
              const res = await fetch(`${url.value}/api/noticia/${id}`,{
                mode:'cors',
                method:'DELETE',
                headers:{
                  'token':token.value,
                  'Content-Type': 'application/json'
                }
              });
              const datos = await res.text();
              if (res.status == 204){
                noticias.value = noticias.value.filter(cat => cat.id != id);
                swal("ha sido eliminado con exito!", {
                  icon: "success",
                });
              }
            }
          });

    }




    return {
      noticias, noticiaDto, guardarNoticia, nombreNoticia, obtenerId, editarNoticia,
      eliminarNoticia
    }
  }
}
</script>






<style scoped>

.col {
  display: grid;
  justify-content: center;
  align-items: center;
}

.table-dark {
  max-width: 60vw;
}

.boton-agregar {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;

}

.button {
  margin: 0;
  background: transparent;
  padding: 0;
  border: none;
}

/* button styling */
.button {
  --border-right: 6px;
  --text-stroke-color: rgba(255,255,255,0.6);
  --animation-color: #9e37ff;
  --fs-size: 2em;
  letter-spacing: 3px;
  text-decoration: none;
  font-size: var(--fs-size);
  font-family: "Arial";
  position: relative;
  text-transform: uppercase;
  color: transparent;
  -webkit-text-stroke: 1px var(--text-stroke-color);
}
/* this is the text, when you hover on button */
.hover-text {
  position: absolute;
  box-sizing: border-box;
  content: attr(data-text);
  color: var(--animation-color);
  width: 0%;
  inset: 0;
  border-right: var(--border-right) solid var(--animation-color);
  overflow: hidden;
  transition: 0.5s;
  -webkit-text-stroke: 1px var(--animation-color);
}
/* hover */
.button:hover .hover-text {
  width: 100%;
  filter: drop-shadow(0 0 23px var(--animation-color))
}




.input-group {
  position: relative;
}

.input {
  border: solid 1.5px #9e9e9e;
  border-radius: 1rem;
  background: none;
  padding: 1rem;
  font-size: 1rem;
  color: #f5f5f5;
  transition: border 150ms cubic-bezier(0.4,0,0.2,1);
}

.user-label {
  position: absolute;
  left: 15px;
  color: #e8e8e8;
  pointer-events: none;
  transform: translateY(1rem);
  transition: 150ms cubic-bezier(0.4,0,0.2,1);
}

.input:focus, input:valid {
  outline: none;
  border: 1.5px solid #1a73e8;
}

.input:focus ~ label, input:valid ~ label {
  transform: translateY(-90%) scale(0.8);
  padding: 0 .2em;
  color: #2196f3;
}

.modal-content {
  background-image: linear-gradient(to bottom right, #734ebd, #881e6f);
  color: white;
}

</style>